import React, { useState, useEffect } from "react";
import { Cookie } from "lucide-react";
import { useI18n } from "../../i18n";
import { Button } from "../ui/Button";

const KEY = "secproctoring.cookie";

export function CookieBanner() {
  const { t } = useI18n();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!window.localStorage.getItem(KEY)) setShow(true);
  }, []);

  if (!show) return null;

  const decide = (value) => {
    window.localStorage.setItem(KEY, value);
    setShow(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-[80] p-4">
      <div className="container-x">
        <div className="flex flex-col items-start gap-4 rounded-2xl border border-border bg-card/95 p-4 shadow-2xl backdrop-blur sm:flex-row sm:items-center">
          <Cookie className="h-6 w-6 shrink-0 text-brand" />
          <p className="flex-1 text-sm text-muted-foreground">{t("cookie.text")}</p>
          <div className="flex gap-2">
            <Button variant="ghost" size="sm" onClick={() => decide("declined")}>
              {t("cookie.decline")}
            </Button>
            <Button size="sm" onClick={() => decide("accepted")}>
              {t("cookie.accept")}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
